import React, {useEffect, useState} from "react";
import {
    facilityActions,
    facilitySlotActions,
    paketinActions,
    useSelector,
    locationActions, resourcesActions
} from "inbooma-api";
import {Biscuit, getAllUrlParams} from "../../../../utils";
import t from '../../../helpers/t';


import FacilityView from './FacilityView';
import SlotsItemView from './SlotsItemView';
import FacilitySidebar from './FacilitySidebar';
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import ShowTrackingsDialog from "./ShowTrackingsDialog";
import ShowGenerateNewPinDialog from "./ShowGenerateNewPinDialog";
import ShowStatusDialog from "./ShowStatusDialog";
import ShowSlotHistoriesDialog from "./ShowSlotHistoriesDialog";
import {_exchangeLabel,getDocHandler, in_array} from "../../../../utils/Helper";
import * as Functions from '../../tasks/components/Functions';
import SortNav from "../../../components/SortNav";
import {$, _} from "../../../../../vendor";
import showNotification from "../../../helpers/showNotification";
import FacilitiesList from "./FacilitiesList";
import Loader from "../../../components/Loader";
import {rbac} from "../index";
import moment from "moment/moment";

const FacilitiesView = props => {
    const {dispatch, params, returnPath, submenuItems, createAccessBar} = props;
    const currentUrl = new URL(window.location.href)
    const searchParams = currentUrl.searchParams;
    const allUrlParams = getAllUrlParams(window.location.href);
    const allUrlParamsClone = {...allUrlParams};
    const [openSubmenus,setOpenSubmenus] = useState([]);
    const [sort,setSort] = useState({
        sort: allUrlParamsClone?.sort !== undefined ? allUrlParamsClone.sort : "name",
        direction: allUrlParamsClone?.direction !== undefined ? allUrlParamsClone.direction : "asc"
    });
    const paginationLimit = 40;
    const language = Biscuit.get('user.lang').replace('-','_');
    const [filters, setFilters] = useState({'includes': 'FacilitySlots','sort': 'name','direction': 'asc','limit': paginationLimit});
    const [userList,setUserList] = useState([]);
    const [locationsList,setLocationsList] = useState([]);
    const [showTrackings, setShowTrackings] = useState(false);
    const [showGenerateNewPin, setShowGenerateNewPin] = useState(false);
    const [showStatusDialog, setShowStatusDialog] = useState(false);
    const [showSlotHistoriesDialog, setShowSlotHistoriesDialog] = useState(false);
    const [tempFacility,setTempFacility] = useState(null);
    const [tempFacilitySlot,setTempFacilitySlot] = useState(null);
    const [showTrackingType, setShowTrackingType] = useState(null);
    const _openDoor = useSelector(state => state.paketins_data.openDoor);
    const _facilities = useSelector(state => state.facilities.facilities);
    const _facility = useSelector(state => state.facilities.facility);
    const _facilitySlot = useSelector(state => state.facilitySlots.facilitySlot);
    const _locations = useSelector(state => state.locations_data.locations);
    const _resources = useSelector(state => state.resources_data.getResources);
    const [facilities, setFacilities] = useState([]);
    const [facility, setFacility] = useState([]);
    const [facilitiesPending, setFacilitiesPending] = useState(false);
    const [facilityPending, setFacilityPending] = useState(false);
    const [facilitySlotPending, setFacilitySlotPending] = useState(false);
    const [locationsPending, setLocationsPending] = useState(false);
    const [resetFilter,setResetFilter] = useState(false);
    const [pagination,setPagination] = useState({
        has_next_page: false,
        current_page: 1
    });
    const [openDoorPending, setOpenDoorPending] = useState(false);
    const [initialized, setInitialized] = useState(false);
    const [resourcesPending, setResourcesPending] = useState(false);
    const [resources, setResources] = useState([]);

    useEffect(() => {
        if(_openDoor.success === "" || !openDoorPending){
            return;
        }
        if(_openDoor.success === true){
            showNotification('success_extended',null,t('successfully opened the door'));
        } else {
            showNotification('warning',null, (_openDoor.data !== null && typeof _openDoor.data.message !== 'undefined'?_openDoor.data.message:typeof _openDoor.data === 'string'?_openDoor.data:null))
        }
        setOpenDoorPending(false);
    },[_openDoor]);

    useEffect(() => {
        if(_resources.success === '' || !resourcesPending){
            return;
        }
        if(_resources.success === true){
            setResources(_resources.data);
        }
        setResourcesPending(false);
    },[_resources]);

    useEffect(() => {
        if(!facilitiesPending || _facilities.success === ''){
            return;
        }
        if(_facilities.success === true){
            setFacilities(_facilities.data);
            setPagination(_facilities.pagination);
            if (openSubmenus.length === 0 && _facilities.data.length > 0) {
                setOpenSubmenus(
                    [...Array(_facilities.data.length)].map((_,i) =>
                        new Object({isOpen: false})
                    )
                );
            }
        }
        setFacilitiesPending(false);
        if(!locationsPending && !facilityPending){
            setInitialized(true);
        }
    }, [_facilities]);

    useEffect(() => {
        if(!facilityPending || _facility.success === ''){
            return;
        }
        if(_facility.success === true){
            setFacility(_facility.data);
        }
        setFacilityPending(false);
        if(!locationsPending && !facilitiesPending){
            setInitialized(true);
        }
    }, [_facility]);

    useEffect(() => {
        if(!facilitySlotPending || _facilitySlot.success === ''){
            return;
        }

        setFacilitySlotPending(false);

    }, [_facilitySlot]);

    useEffect(() => {
        if(_locations.success === '' || !locationsPending){
            return;
        }

        if(_locations.success === true){
            let empty = locationsList.length < 1;
            if (empty && _locations.data.length > 0) {
                let locations = _getObjectFromArray(_locations.data);
                setLocationsList(locations);
            }
        }
        setLocationsPending(false);
        if(!facilitiesPending && !facilityPending ){
            setInitialized(true);
        }
    }, [_locations]);

    useEffect(() => {
        if(initialized || facilitiesPending || facilityPending){
            return true;
        }
// mark main menu

            dispatch(facilityActions.resetFacility());
            let requestFilter = {...filters};
            if(params.facilityId !== null){
                requestFilter ={...requestFilter,id:params.facilityId};
            }
            Object.keys(params).map((val) =>{
                if(!in_array(val,['add','facilityId','returnPath','id']) && params[val] !== null){
                    requestFilter[val] = params[val];
                }
            });
            let mainMenu = document.getElementById('inb-main-menu');
            if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector('.l-contingents')) {
                if (mainMenu.querySelector('.active') != null) mainMenu.querySelector('.active').classList.remove('active');
                mainMenu.querySelector('.l-contingents').classList.add('active');
            }
            dispatch(locationActions.getLocations({
                token: Biscuit.get('token'),
                suffix: "",
                filter: {
                    'findForSelect': true
                },
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setLocationsPending(true);
            if(params.id !== null){
                dispatch(facilityActions.getFacility({
                    token: Biscuit.get('token'),
                    suffix: "",
                    id: params.id,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
                setFacilityPending(true);
                dispatch(resourcesActions.getResources({
                    token: Biscuit.get('token'),
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
                setResourcesPending(true);
                if(params.facilitySlotId !== null){
                    dispatch(facilitySlotActions.getFacilitySlot({
                        token: Biscuit.get('token'),
                        suffix: "",
                        id: params.facilitySlotId,
                        parameters: {
                            headers: {
                                'Accept-Language': language,
                                'Content-Language': language
                            }
                        }
                    }));
                    setFacilitySlotPending(true);
                }
            } else {
                dispatch(facilityActions.getFacilities({
                    token: Biscuit.get('token'),
                    suffix: "",
                    filter: requestFilter,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
                setFacilitiesPending(true);
            }
    },[]);

    const _getObjectFromArray = (array) => {
        return array.reduce((obj,entity) => {
            obj[entity.id] = entity;
            return obj;
        },{});
    };

    const onShowTrackings = (facility, type) => {
        setShowTrackingType(type);
        setTempFacility(facility);
        setShowTrackings(true);
    }

    const onShowGenerateNewPin = (facility) => {
        setTempFacility(facility);
        setShowGenerateNewPin(true);
    }

    const onRemoveSlot = (slot) => {
        if (confirm(t('really_remove'))) {
            props.dispatch(facilitySlotActions.deleteFacilitySlot(
                {
                    id: Number(slot.id),
                    token: Biscuit.get('token'),
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }
            ));
        }
    }

    const onOpenDoor = (type,slot) => {
        props.dispatch(paketinActions.openDoor({
            token: Biscuit.get('token'),
            id: (type === 'slot'?slot.slot_external_id:slot.external_id),
            type: type,
            fcId: (type === 'slot'?slot.facility_id:slot.id)
        }));
        setOpenDoorPending(true);
    }

    const onOpenSlot = (slot) => {
        props.dispatch(resourcesActions.openSlot({
            token: Biscuit.get('token'),
            facility_slot_id: slot.id,
        }));
        setOpenDoorPending(true);
    }

    const showStatus = (slot) => {
        setTempFacilitySlot(slot);
        setShowStatusDialog(true);
    }

    const showSlotHistories = (slot) => {
        setTempFacilitySlot(slot);
        setShowSlotHistoriesDialog(true);
    }


    const getLocationById = (id) => {

        if (id === undefined || id == null || locationsList === undefined) return '';

        let empty = true;
        for (let i in locationsList) {
            empty = false;
            break;
        }
        if (!empty && locationsList[id] !== undefined && locationsList[id] != null) return locationsList[id].name;
        else return '';
    };

    const openSubmenuHandle = (e,index) => {

        let clone = [...openSubmenus];
        clone[index].isOpen = !clone[index].isOpen;
        setOpenSubmenus(clone);
    };

    const isSubmenuOpen = (index) => {

        if (typeof openSubmenus === 'undefined' || openSubmenus == null || openSubmenus.length <= index)
            return false;

        return openSubmenus[index].isOpen;
    };

    const onCloseFacility = () => {
        props.dispatch(facilityActions.resetFacility());
    };

    const onRemoveFacility = (facility) => {
        if (confirm(t('really_remove'))) {
            props.dispatch(facilityActions.deleteFacility(
                {
                    id: Number(facility.id),
                    token: Biscuit.get('token'),
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }
            ));
        }
    };
    const handleCloseDialog = () => {
        setShowTrackings(false);
        setShowGenerateNewPin(false);
        setShowStatusDialog(false);
        setShowSlotHistoriesDialog(false);
        setTempFacility(null);
        setTempFacilitySlot(null);
    }

    const onFilterChanged = (filter) => {

        props.dispatch(facilityActions.getFacilities({
            token: Biscuit.get('token'),
            filter: filter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
    };


    const onGetQRCodeHandler = (facility) => {
        getDocHandler('/facilities/getQRCodeFacility/'+facility.id,'GET','image/png',facility.name + '.png','',facility.id);
    };

    const onSortChangedHandle = (ev) => {

        const el = ev.currentTarget;
        const sortKey = el.getAttribute('data-inb-val'),
            direction = el.getAttribute('data-inb-direction'),
            isOppositeElement = (direction === null && el.classList.contains('is-active')),
            newDirection = (direction === 'desc' || isOppositeElement ? 'asc' : 'desc');

        if (sortKey) {
            let requestFilter;
            if(typeof filters.limit !== 'undefined') {
                requestFilter = {
                    ...filters,
                    sort: sortKey,
                    direction: direction
                };
            } else {
                requestFilter = {
                    ...filters,
                    sort: sortKey,
                    direction: direction,
                    limit: paginationLimit,
                    page: 1
                };
            }

            props.dispatch(facilityActions.getFacilities({
                token: Biscuit.get('token'),
                suffix: "",
                filter: requestFilter,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setFacilitiesPending(true);
            setSort({
                sort: sortKey,
                direction: direction
            });

            const activeSortTab = $('.is-active');
            _.each(activeSortTab, function(key){
                key["classList"].remove('is-active');
            });
            el.classList.add('is-active');
            el.setAttribute('data-inb-direction', (isOppositeElement ? 'desc' : newDirection));
        }
    };

    const tabs =[{
        name: t('designation'),
        smallWidth: 6,
        mediumWidth: 2,
        title: t('sort_by_${a}',{a:t('designation')},'capital'),
        canSort: true,
        preselected: true,
        sort: {
            direction: sort.direction,
            data_inb_val: 'name'
        }
    },{
        name: t('location',null,'capital'),
        smallWidth: 6,
        mediumWidth: 2,
        title: t('location',null,'capital'),
        canSort: false
    },{
        name: t('facility_type',null,'capital'),
        mediumWidth: 2,
        smallWidth: 6,
        title: t('facility_type',null,'capital'),
        canSort: false
    }, {
        name: t('error_text',null,'capital'),
        smallWidth: 6,
        mediumWidth: 1,
        title: t('error_text',null,'capital'),
        canSort: false
    }, {
        name: t('facility_modified'),
        smallWidth: 6,
        mediumWidth: 2,
        title: t('sort_by_${a}', {a: t('facility_modified')}, 'capital'),
        canSort: true,
        preselected: false,
        sort: {
            direction: 'asc',
            data_inb_val: 'modified'
        }
    }
    ];

    const loadNextPage = (page) => {

        // if (!pagination.has_next_page) return;

        setFacilitiesPending(true);

        let requestFilter = {...filter};
        if(allUrlParams?.item !== undefined){
            delete requestFilter.begin_gte;
        }
        requestFilter.sort = sort.sort;
        requestFilter.direction = sort.direction;
        requestFilter.limit = paginationLimit;
        requestFilter.page = page;
        // fetch next page
        setFacilities([]);
        dispatch(facilityActions.getFacilities({
            token: Biscuit.get('token'),
            suffix: "",
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
    };
    return (
        <>
            <FacilitySidebar
                facilities={facilities}
                setSelectedFilter={onFilterChanged}
            />
            <div id="inb-c-main" className="columns">
                {props.createAccessBar &&
                    <InboomaSubmenu
                        tabs={submenuItems}
                        extraClasses={"sticky-top"}
                        smallOnlyTitle={t(_exchangeLabel('facilities'),null,'capital')}
                        pagination={pagination}
                        itemsCountPerPage={paginationLimit}
                        pageRangeDisplayed={5}
                        onChange={loadNextPage}
                        initialized={initialized}
                        itemLength={facilities.length}
                    />
                }
                <SortNav
                    tabs={tabs}
                    extraClasses={"sticky-top-sortbar"}
                    listStyle="tight"
                    handler={onSortChangedHandle}/>


                <div className="off-canvas-wrapper">
                    {!facilitiesPending && facilities.length > 0 && <FacilitiesList
                        dispatch={dispatch}
                        facilities={facilities}
                        isSubmenuOpen={isSubmenuOpen}
                        getLocationById={getLocationById}
                        _exchangeLabel={_exchangeLabel}
                        onShowTrackings={onShowTrackings}
                        onShowGenerateNewPin={onShowGenerateNewPin}
                        onRemoveFacility={onRemoveFacility}
                        onGetQRCodeHandler={onGetQRCodeHandler}
                        onOpenDoor={onOpenDoor}
                        onOpenSlot={onOpenSlot}
                        onRemoveSlot={onRemoveSlot}
                        showStatus={showStatus}
                        onShowSlotHistories={showSlotHistories}
                        openSubmenuHandle={openSubmenuHandle}/>}
                    {facilitiesPending && <Loader
                        mediumWidth={2}
                        smallWidth={4}
                        subLoaders={5}/>
                    }
                    {!facilitiesPending && facilities.length < 1 &&
                        <div
                            id="inb-app-collection-empty"
                            className="inb-announcement"
                            style={{ minHeight: "1150px" }}
                        >
                            <div className="inb-image-box">
                                <img alt="No Data" src={"assets/img/no_data.svg"}/>
                            </div>
                            <h3>
                                { t('app_msg_collection_empty') }
                            </h3>
                            <p>
                                { t('app_msg_collection_empty_body') }
                            </p>
                        </div>
                    }
                </div>

            </div>
            {!facilityPending && ((params.id !== null && facility !== [] && params.edit) || (params.add !== null && params.add)) && rbac.hasPermission('editFacility')  && locationsList !== [] && !locationsPending && initialized &&
                <FacilityView
                    onClose={onCloseFacility}
                    dispatch={dispatch}
                    facility={facility}
                    locations={locationsList}
                    getUserNameById={Functions.getUserNameById}
                    showNotification={showNotification}
                />
            }
            { !facilityPending && !facilitySlotPending && rbac.hasPermission('editFacility') && (params.addFacilitySlot || params.facilitySlotId !== null)  &&
                <SlotsItemView
                    slot={typeof _facilitySlot.data !== 'undefined'?_facilitySlot.data:null}
                    resources={resources}
                    facility={facility}
                    language={language}
                    dispatch={dispatch}
                    name={(facility.facility_type === 'general_paketin_pin' || facility.facility_type === 'general_paketin_admin' && facility.booking_type === 'contingent')?t('box'):t('slot')}
                    returnPath={"/facilities"}/>
            }
            {showTrackings && <ShowTrackingsDialog
                handleCloseDialog={handleCloseDialog}
                facility={tempFacility}
                showTrackingType={showTrackingType}
                dispatch={dispatch}
            />}
            {showGenerateNewPin && <ShowGenerateNewPinDialog
                handleCloseDialog={handleCloseDialog}
                facility={tempFacility}
                showNotification={showNotification}
                dispatch={dispatch}
            />}
            {showStatusDialog && <ShowStatusDialog
                handleCloseDialog={handleCloseDialog}
                facilitySlot={tempFacilitySlot}
                dispatch={dispatch}
            />}
            {showSlotHistoriesDialog && <ShowSlotHistoriesDialog
                handleCloseDialog={handleCloseDialog}
                facilitySlot={tempFacilitySlot}
                dispatch={dispatch}
               />}
        </>
    );
};
export default FacilitiesView;